
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'InputText',
  components: {
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      default: '',
      // required: true,
    },

    rules: {
      type: [String, Object],
      default: '',
    },
    vid: {
      type: [String, Object],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 100,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordVisible: true,
      inputId: `input-text-${this._uid}`,
    }
  },
}
